import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

const resources = {
  tr: {
    translation: {
      hero: {
        title: 'Zamanın Ötesinde',
        subtitle: 'Lüks ve Güvenin Buluşma Noktası',
      },
      about: {
        title: 'Hakkımızda',
        p1: "Saatbahane olarak, zamanın sadece bir ölçü birimi değil, bir yaşam tarzı olduğuna inanıyoruz. İstanbul'un kalbi Levent'te, lüks saat koleksiyonculuğunu tutkuyla birleştiriyoruz.",
        p2: "Dünyanın en prestijli markaları olan Rolex, Patek Philippe, Audemars Piguet ve Cartier gibi devlerin nadide parçalarını, %100 orijinallik garantisi ve uzman ekspertiz raporlarıyla sizlere sunuyoruz.",
        vision: 'Sadece saat satmak değil, saat tutkunları için güvenilir bir liman olmak. Şeffaflık, dürüstlük ve müşteri memnuniyeti, ticaretimizin temel taşlarıdır.',
        p3: 'Her hafta Instagram üzerinden düzenlediğimiz canlı yayın mezatlarımızla, bu seçkin dünyayı evinize getiriyoruz. Saatbahane ailesine katılarak, sadece bir saat değil, bir miras satın alırsınız.',
      },
      nav: { home: 'Ana Sayfa', collection: 'Koleksiyon', contact: 'İletişim', about: 'Hakkımızda' },
      footer: { rights: 'Tüm hakları saklıdır.', about: 'Hakkımızda', privacy: 'Gizlilik & KVKK', terms: 'Kullanım Koşulları' },
      cta: { whatsapp: 'WhatsApp ile İletişime Geç' },
      collection: {
        title_highlight: 'Özel',
        title: 'Koleksiyon',
        all: 'Tümü',
        subtitle: 'Dünyanın en prestijli markalarından seçilmiş eşsiz parçalar.',
        original: '%100 Orijinal',
        desc_placeholder: 'Bu eşsiz parça, zarafet ve ustalığın mükemmel birleşimini sunuyor.',
        ask_price: 'Fiyat Sorunuz',
        inquire: 'Bilgi Al',
      },
      social: { title: 'Canlı Yayın Müzayedeleri', subtitle: "Haftada 3 gün, en özel parçalar ve uzman yorumları için Instagram'da bize katılın." },
      contact: { about_text: "Lüks saatlerin İstanbul'daki en güvenilir adresi. Dünyanın en seçkin saatlerini %100 orijinitelik garantisiyle alıp satıyoruz.", title: 'Bize Ulaşın' },
      sell_watch: {
        title: 'Saatleriniz Değerinde Satın Alınır!',
        subtitle: 'Eski saatiniz, yeni sermayeniz.',
        desc: 'Markalı lüks saatinizi nakit satmak veya komisyonlu (konsinye) satış ile değerlendirmek ister misiniz? Uzmanlarımız anında fiyat versin.',
        cta: "WhatsApp'tan Teklif Al",
        why_us: 'Neden Saatbahane?',
        reason1: 'Hızlı & Güvenli Ödeme',
        reason2: 'Gerçek Piyasa Değeri',
        reason3: 'Uzman Ekspertiz',
      },
    },
  },
  en: {
    translation: {
      hero: { title: 'Beyond Time', subtitle: 'Where Luxury Meets Trust' },
      about: {
        title: 'About Us',
        p1: 'At Saatbahane, we believe time is not just a measurement, but a lifestyle. In the heart of Istanbul, Levent, we combine luxury watch collecting with passion.',
        p2: "We offer rare pieces from the world's most prestigious brands like Rolex, Patek Philippe, Audemars Piguet, and Cartier, with a 100% authenticity guarantee and expert appraisal reports.",
        vision: 'Not just selling watches, but being a safe harbor for watch enthusiasts. Transparency, honesty, and customer satisfaction are the cornerstones of our trade.',
        p3: 'We bring this exclusive world to your home with our weekly live auctions on Instagram. By joining the Saatbahane family, you buy not just a watch, but a legacy.',
      },
      nav: { home: 'Home', collection: 'Collection', contact: 'Contact', about: 'About Us' },
      footer: { rights: 'All rights reserved.', about: 'About Us', privacy: 'Privacy & GDPR', terms: 'Terms of Service' },
      cta: { whatsapp: 'Contact via WhatsApp' },
      collection: {
        title_highlight: 'Exclusive',
        title: 'Collection',
        all: 'All',
        subtitle: "Unique pieces selected from the world's most prestigious brands.",
        original: '100% Original',
        desc_placeholder: 'This unique piece offers the perfect combination of elegance and craftsmanship.',
        ask_price: 'Ask for Price',
        inquire: 'Inquire',
      },
      social: { title: 'Live Instagram Auctions', subtitle: 'Join us 3x a week for exclusive pieces and expert insights on Instagram.' },
      contact: { about_text: "Istanbul's premier destination for luxury timepieces. We buy, sell, and trade the world's finest watches with 100% authenticity guarantee.", title: 'Contact Us' },
      sell_watch: {
        title: 'We Buy Your Watches at True Value!',
        subtitle: 'Your old watch, your new capital.',
        desc: 'Want to sell your luxury watch for cash or consign it for a better price? Get an instant quote from our experts.',
        cta: 'Get Offer via WhatsApp',
        why_us: 'Why Saatbahane?',
        reason1: 'Fast & Secure Payment',
        reason2: 'True Market Value',
        reason3: 'Expert Appraisals',
      },
    },
  },
  de: {
    translation: {
      hero: { title: 'Jenseits der Zeit', subtitle: 'Wo Luxus auf Vertrauen trifft' },
      about: {
        title: 'Über Uns',
        p1: 'Bei Saatbahane glauben wir, dass Zeit nicht nur ein Maß, sondern ein Lebensstil ist. Im Herzen von Istanbul, Levent, verbinden wir das Sammeln von Luxusuhren mit Leidenschaft.',
        p2: 'Wir bieten Ihnen seltene Stücke der renommiertesten Marken der Welt wie Rolex, Patek Philippe, Audemars Piguet und Cartier, mit 100% Echtheitsgarantie und Expertenberichten.',
        vision: 'Nicht nur Uhren verkaufen, sondern ein sicherer Hafen für Uhrenliebhaber sein. Transparenz, Ehrlichkeit und Kundenzufriedenheit sind die Eckpfeiler unseres Handels.',
        p3: 'Wir bringen diese exklusive Welt mit unseren wöchentlichen Live-Auktionen auf Instagram zu Ihnen nach Hause. Wenn Sie der Saatbahane-Familie beitreten, kaufen Sie nicht nur eine Uhr, sondern ein Erbe.',
      },
      nav: { home: 'Startseite', collection: 'Kollektion', contact: 'Kontakt', about: 'Über Uns' },
      footer: { rights: 'Alle Rechte vorbehalten.', about: 'Über Uns', privacy: 'Datenschutz', terms: 'AGB' },
      cta: { whatsapp: 'Kontakt über WhatsApp' },
      collection: {
        title_highlight: 'Exklusive',
        title: 'Kollektion',
        all: 'Alle',
        subtitle: 'Einzigartige Stücke, ausgewählt von den renommiertesten Marken der Welt.',
        original: '100% Original',
        desc_placeholder: 'Dieses einzigartige Stück bietet die perfekte Kombination aus Eleganz und Handwerkskunst.',
        ask_price: 'Preis auf Anfrage',
        inquire: 'Anfragen',
      },
      social: { title: 'Live-Auktionen auf Instagram', subtitle: 'Seien Sie 3x pro Woche dabei für exklusive Stücke und Expertenwissen.' },
      contact: { about_text: 'Istanbuls erste Adresse für Luxusuhren. Wir kaufen, verkaufen und tauschen die feinsten Uhren der Welt mit 100% Echtheitsgarantie.', title: 'Kontakt' },
      sell_watch: {
        title: 'Wir kaufen Ihre Uhr zum Bestpreis!',
        subtitle: 'Ihre alte Uhr, Ihr neues Kapital.',
        desc: 'Möchten Sie Ihre Luxusuhr gegen Bargeld verkaufen oder in Kommission geben? Holen Sie sich ein Sofortangebot von unseren Experten.',
        cta: 'Angebot per WhatsApp erhalten',
        why_us: 'Warum Saatbahane?',
        reason1: 'Schnelle & sichere Zahlung',
        reason2: 'Echter Marktwert',
        reason3: 'Experten-Gutachten',
      },
    },
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr',
    supportedLngs: ['tr', 'en', 'de'],
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
    interpolation: { escapeValue: false },
  })

export default i18n

